<template>
  <div class="m-market-11-total">
    <div class="m-market-11-top">
      <div class="m-title-player" />
      <div class="m-market-11-top-right">
        <div class="m-title" />
        <template v-for="title in marketTitles">
          <div
            :key="title"
            class="m-title"
          >
            {{ title }}
          </div>
        </template>
      </div>
    </div>

    <template v-for="(value, key) in playerMap">
      <div
        :key="key"
        class="m-market-row"
      >
        <div class="m-player">
          {{ getPlayerName(value[0].description) }}
        </div>
        <Market
          :markets="value"
          :outcome-size="3"
          :market-titles="marketTitles"
          :event="event"
        />
      </div>
    </template>
  </div>
</template>

<script>
/**
 * 聚合显示 players, 将球员名称置于左侧一列, 展示对应球员下所有outcome及对应specifier下的赔率
 * 展示对应球员下所有specifier，默认选中最小值，点击展开下拉框中可选择其他specifier值，交互同当前站内specifier选择交互（目前，该类market一个球员只有一个specifier)
 * 将相同market id的所有outcome展示在同一个market下
 * 球员排序：比较球员中第一个outcome（Over）赔率值（在默认specifier下），按照赔率值从小到大对球员进行排序；赔率值相同的按照outcome id进行排序
 */
import Market from './Market'

export default {
  name: 'Market11XTotal',
  components: {
    Market
  },
  props: {
    markets: {
      type: Array,
      default: () => []
    },
    event: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    return {
      marketTitles: ['Over', 'Under'],
      sortedMarkets: []
    }
  },
  computed: {
    playerMap() {
      const playerMap = {}
      this.sortedMarkets.forEach((x) => {
        const playerId = x.specifiers.split('|player=')[1]
        if (!playerMap[playerId]) {
          playerMap[playerId] = [x]
        } else {
          playerMap[playerId].push(x)
        }
      })
      return playerMap
    }
  },
  created() {
    this.getSortedMarkets()
  },
  methods: {
    getPlayerName(description) {
      return description.split('total ')[0].trim()
    },
    getSortedMarkets() {
      const tempMarkets = [...this.markets]
        .filter((x) => x.status === 0 || x.status === 1)
        .map((x) => {
          const { map, order } = x.outcomes
          order.sort((a) => {
            if (/over/i.test(map[a].description)) return -1
            else return 1
          })
          return x
        })
      tempMarkets.sort((a, b) => {
        const diff = parseFloat(a.outcomes.map[a.outcomes.order[0]].odds) - parseFloat(b.outcomes.map[b.outcomes.order[0]].odds)
        if (diff > 0) return 1
        else if (diff < 0) return -1
        const playerNameA = this.getPlayerName(a.description)
        const playerNameB = this.getPlayerName(b.description)
        if (playerNameA < playerNameB) return -1
        else if (playerNameA > playerNameB) return 1
        return 0
      })
      this.sortedMarkets = tempMarkets
    }
  }
}
</script>

<style lang="scss" scoped>
.m-market-11-top {
  display: flex;

  .m-title {
    width: 64px;
    flex: 1 1 32%;
    padding: 0;
    margin: 12px 0 12px 4px;
    color: #ccc;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
  }

  &-right {
    display: flex;
    flex: 1;
  }
}

.m-market-11-total {
  .m-title-player {
    width: 120px;
  }

  .m-player {
    display: flex;
    width: 120px;
    height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-right: 4px;
    background: #ccc;
    color: #333;
    line-height: 16px;
    text-align: center;
  }

  .m-market-row {
    margin: 0;

    ::v-deep .m-outcome {
      max-width: 32%;
      flex: 1 1 32%;
      margin: 0 4px 4px 0;

      &:nth-of-type(3) {
        margin-right: 0;
      }
    }
  }
}
</style>
